const Province = () =>
  import(
    /* webpackChunkName: "base-info-geo-province" */ '@/pages/base-info/geo/province/index.vue'
  )
const CreateProvince = () =>
  import(
    /* webpackChunkName: "base-info-geo-province" */ '@/pages/base-info/geo/province/create.vue'
  )
const EditProvince = () =>
  import(
    /* webpackChunkName: "base-info-geo-province" */ '@/pages/base-info/geo/province/edit.vue'
  )

export default {
  path: 'province',
  meta: {
    label: 'province',
    auth: 'province'
  },
  component: {
    name: 'Province',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoGeoProvince',
      path: '/',
      meta: { label: 'Index' },
      component: Province
    },
    {
      name: 'BaseInfoCreateGeoProvince',
      path: 'create',
      meta: { label: 'Add' },
      component: CreateProvince
    },
    {
      name: 'BaseInfoEditGeoProvince',
      path: 'edit/:id',
      meta: { label: 'Edit' },
      component: EditProvince,
      props: true
    }
  ]
}
